import {Flex,  SVGButton} from '/app/src/component';
import React from 'react';

export default ({changed, onClick}) => {
    const HeaderStyle = {
        dataName: 'OfflineSettingsHeader',
        width: '100%',
        vAlignContent: 'center',
        hAlignContent: 'right',
        padding: '10px 30px',
        column: true,
        shrink: 0
    }
    const SaveButtonStyle = {
        dataName: 'OfflineSettingsSaveButton',
        border: true,
        color: 'black',
        hover: 'blue',
    }
    const SaveButtonProps = {
        text: 'Spara',
        src: '/images/Save.svg',
        disabled: !changed,
        onClick: onClick
    }
    return (
        <Flex {...HeaderStyle}>
            <SVGButton {...SaveButtonStyle} {...SaveButtonProps}/>
            <Flex h='10px' fontSize='12px' fontWeight='400' color='darkgrey' mt='2px'>
                {changed && '*Ändringar är inte sparade'}
            </Flex>
        </Flex>
    )
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/OfflineSettings/_Header.js